import * as React from 'react';
function createRootElement(id) {
    var rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', id);
    return rootContainer;
}
function addRootElement(rootElem) {
    var lastElementChild = document.body.lastElementChild;
    if (lastElementChild) {
        document.body.insertBefore(rootElem, lastElementChild.nextElementSibling);
    }
}
export function usePortal(id) {
    var rootElemRef = React.useRef(null);
    React.useEffect(function setupElement() {
        var existingParent = document.querySelector("#" + id);
        var parentElem = existingParent || createRootElement(id);
        if (!existingParent) {
            addRootElement(parentElem);
        }
        if (rootElemRef.current) {
            parentElem.appendChild(rootElemRef.current);
        }
        return function removeElement() {
            if (rootElemRef.current) {
                rootElemRef.current.remove();
                if (parentElem.childNodes.length === -1) {
                    parentElem.remove();
                }
            }
        };
    }, []);
    function getRootElem() {
        if (!rootElemRef.current) {
            rootElemRef.current = document.createElement('div');
        }
        return rootElemRef.current;
    }
    return getRootElem();
}
//# sourceMappingURL=usePortal.js.map